<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px; font-size:small">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Parámetros POA</h5>
          <div class="row mb-3">
            <div class="col-md-7">
              <div class="form-group">
                <div class="input-group">
                  <input
                    type="text"
                    v-model="filters.search"
                    class="form-control"
                    :placeholder="`Buscar por código o ${getSearchPlaceholder()}...`"
                    @keyup.enter="handleSearch"
                  />
                  <button 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-5 text-end">
              <BButton
                v-if="hasPermission('param_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nuevo {{ getCurrentTabName() }}
              </BButton>
              <BButton
                v-if="hasPermission('param_create')"
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Tabs -->
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
              <a 
                class="nav-link" 
                :class="{ active: activeTab === 'fuente' }"
                href="#" 
                @click.prevent="changeTab('fuente')"
              >
                <i class="fa fa-bank me-1"></i> Fuentes Financiamiento
              </a>
            </li>
            <li class="nav-item">
              <a 
                class="nav-link" 
                :class="{ active: activeTab === 'programa' }"
                href="#" 
                @click.prevent="changeTab('programa')"
              >
                <i class="fa fa-tasks me-1"></i> Programas POA
              </a>
            </li>
            <li class="nav-item">
              <a 
                class="nav-link" 
                :class="{ active: activeTab === 'actividad' }"
                href="#" 
                @click.prevent="changeTab('actividad')"
              >
                <i class="fa fa-list-alt me-1"></i> Actividades POA
              </a>
            </li>
          </ul>

          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <!-- Tabla Fuentes Financiamiento -->
            <div v-show="activeTab === 'fuente'">
              <div class="table-responsive">
                <table class="table table-sm table-striped table-hover table-bordered">
                  <thead class="text-primary">
                    <tr style="line-height: 8px; font-size: 0.8rem;">
                      <th>Código</th>
                      <th>Fuente Financiamiento</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in fuentes" :key="item.codigo">
                      <td>{{ item.codigo }}</td>
                      <td>{{ item.fuente_financiamiento }}</td>
                      <td>
                        <div class="btn-group">
                          <BButton
                            v-if="hasPermission('param_update')"
                            @click="showModal(item)"
                            variant="warning"
                            size="sm"
                            class="me-1"
                          >
                            <i class="fa fa-edit"></i>
                          </BButton>
                          <BButton
                            v-if="hasPermission('param_delete')"
                            @click="confirmDelete(item, 'fuente')"
                            variant="danger"
                            size="sm"
                          >
                            <i class="fa fa-trash"></i>
                          </BButton>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="fuentes.length === 0">
                      <td colspan="3" class="text-center">No hay datos registrados</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-3" v-if="paginationFuente.total > 0">
                <div class="col-md-12">
                  <BPagination
                    v-model="paginationFuente.current_page"
                    :total-rows="paginationFuente.total"
                    :per-page="paginationFuente.per_page"
                    @update:modelValue="handlePageChange"
                    align="center"
                  ></BPagination>
                </div>
              </div>
            </div>

            <!-- Tabla Programas POA -->
            <div v-show="activeTab === 'programa'">
              <div class="table-responsive">
                <table class="table table-sm table-striped table-hover table-bordered">
                  <thead class="text-primary">
                    <tr style="line-height: 8px; font-size: 0.8rem;">
                      <th>Código</th>
                      <th>Programa POA</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in programas" :key="item.codigo">
                      <td>{{ item.codigo }}</td>
                      <td>{{ item.programa_poa }}</td>
                      <td>
                        <div class="btn-group">
                          <BButton
                            v-if="hasPermission('param_update')"
                            @click="showModal(item)"
                            variant="warning"
                            size="sm"
                            class="me-1"
                          >
                            <i class="fa fa-edit"></i>
                          </BButton>
                          <BButton
                            v-if="hasPermission('param_delete')"
                            @click="confirmDelete(item, 'programa')"
                            variant="danger"
                            size="sm"
                          >
                            <i class="fa fa-trash"></i>
                          </BButton>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="programas.length === 0">
                      <td colspan="3" class="text-center">No hay datos registrados</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-3" v-if="paginationPrograma.total > 0">
                <div class="col-md-12">
                  <BPagination
                    v-model="paginationPrograma.current_page"
                    :total-rows="paginationPrograma.total"
                    :per-page="paginationPrograma.per_page"
                    @update:modelValue="handlePageChange"
                    align="center"
                  ></BPagination>
                </div>
              </div>
            </div>

            <!-- Tabla Actividades POA -->
            <div v-show="activeTab === 'actividad'">
              <div class="table-responsive">
                <table class="table table-sm table-striped table-hover table-bordered">
                  <thead class="text-primary">
                    <tr style="line-height: 8px; font-size: 0.8rem;">
                      <th>Código</th>
                      <th>Actividad POA</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in actividades" :key="item.codigo">
                      <td>{{ item.codigo }}</td>
                      <td>{{ item.actividad_poa }}</td>
                      <td>
                        <div class="btn-group">
                          <BButton
                            v-if="hasPermission('param_update')"
                            @click="showModal(item)"
                            variant="warning"
                            size="sm"
                            class="me-1"
                          >
                            <i class="fa fa-edit"></i>
                          </BButton>
                          <BButton
                            v-if="hasPermission('param_delete')"
                            @click="confirmDelete(item, 'actividad')"
                            variant="danger"
                            size="sm"
                          >
                            <i class="fa fa-trash"></i>
                          </BButton>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="actividades.length === 0">
                      <td colspan="3" class="text-center">No hay datos registrados</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-3" v-if="paginationActividad.total > 0">
                <div class="col-md-12">
                  <BPagination
                    v-model="paginationActividad.current_page"
                    :total-rows="paginationActividad.total"
                    :per-page="paginationActividad.per_page"
                    @update:modelValue="handlePageChange"
                    align="center"
                  ></BPagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="md"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Código</label>
              <input
                type="text"
                v-model="form.codigo"
                class="form-control"
                :class="{ 'is-invalid': errors.codigo }"
                required
                :disabled="isEditing"
                maxlength="15"
              />
              <div class="invalid-feedback" v-if="errors.codigo">
                {{ errors.codigo[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">{{ getFieldLabel() }}</label>
              <input
                type="text"
                v-model="form.nombre"
                class="form-control"
                :class="{ 'is-invalid': errors.nombre }"
                required
                :maxlength="getMaxLength()"
              />
              <div class="invalid-feedback" v-if="errors.nombre">
                {{ errors.nombre[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BPagination } from 'bootstrap-vue-3';

interface FuenteFinanciamiento {
  codigo: string;
  fuente_financiamiento: string;
}

interface ProgramaPoa {
  codigo: string;
  programa_poa: string;
}

interface ActividadPoa {
  codigo: string;
  actividad_poa: string;
}

interface PaginationData {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
}

export default {
  components: {
    BModal,
    BButton,
    BPagination
  },
  setup() {
    const fuentes = ref<FuenteFinanciamiento[]>([]);
    const programas = ref<ProgramaPoa[]>([]);
    const actividades = ref<ActividadPoa[]>([]);
    const loading = ref(false);
    const authStore = useAuthStore();
    const activeTab = ref('fuente');
    const filters = ref({
      search: ''
    });
    
    // Variables para el modal
    const modalVisible = ref(false);
    const isEditing = ref(false);
    const loadingForm = ref(false);
    const errors = ref<Record<string, string[]>>({});
    const currentItemType = ref('fuente');

    const form = ref({
      codigo: '',
      nombre: ''
    });

    // Paginación por cada tabla
    const paginationFuente = ref<PaginationData>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const paginationPrograma = ref<PaginationData>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const paginationActividad = ref<PaginationData>({
      current_page: 1,
      per_page: 10,
      total: 0,
      last_page: 1
    });

    const modalTitle = computed(() => {
      const action = isEditing.value ? 'Editar' : 'Nuevo';
      return `${action} ${getCurrentTabName()}`;
    });

    const getCurrentTabName = () => {
      switch (activeTab.value) {
        case 'fuente': return 'Fuente Financiamiento';
        case 'programa': return 'Programa POA';
        case 'actividad': return 'Actividad POA';
        default: return '';
      }
    };

    const getSearchPlaceholder = () => {
      switch (activeTab.value) {
        case 'fuente': return 'fuente financiamiento';
        case 'programa': return 'programa POA';
        case 'actividad': return 'actividad POA';
        default: return '';
      }
    };

    const getFieldLabel = () => {
      switch (currentItemType.value) {
        case 'fuente': return 'Fuente Financiamiento';
        case 'programa': return 'Programa POA';
        case 'actividad': return 'Actividad POA';
        default: return 'Nombre';
      }
    };

    const getMaxLength = () => {
      switch (currentItemType.value) {
        case 'fuente': return 100;
        case 'programa': return 100;
        case 'actividad': return 100;
        default: return 100;
      }
    };

    const getEndpoint = () => {
      switch (currentItemType.value) {
        case 'fuente': return 'fuente-financiamiento';
        case 'programa': return 'programa-poa';
        case 'actividad': return 'actividad-poa';
        default: return '';
      }
    };

    const getCurrentPagination = () => {
      switch (activeTab.value) {
        case 'fuente': return paginationFuente.value;
        case 'programa': return paginationPrograma.value;
        case 'actividad': return paginationActividad.value;
        default: return paginationFuente.value;
      }
    };

    const setCurrentPagination = (data: PaginationData) => {
      switch (activeTab.value) {
        case 'fuente':
          paginationFuente.value = data;
          break;
        case 'programa':
          paginationPrograma.value = data;
          break;
        case 'actividad':
          paginationActividad.value = data;
          break;
      }
    };

    const changeTab = async (tab: string) => {
      if (activeTab.value === tab) return;
      
      activeTab.value = tab;
      filters.value.search = '';
      
      // Resetear paginación del tab actual
      const pagination = getCurrentPagination();
      pagination.current_page = 1;
      
      // Cargar datos del tab seleccionado
      await loadTabData();
    };

    const loadTabData = async () => {
      loading.value = true;
      const endpoint = getEndpointByTab(activeTab.value);
      const pagination = getCurrentPagination();
      
      try {
        const params: Record<string, any> = {
          page: pagination.current_page,
          per_page: pagination.per_page
        };
        
        if (filters.value.search) {
          params.search = filters.value.search;
        }
        
        const response = await axios.get(`/parametros-poa/${endpoint}/list`, { params });
        const data = response.data;
        
        switch (activeTab.value) {
          case 'fuente':
            fuentes.value = data.items.data;
            paginationFuente.value = {
              current_page: data.items.current_page,
              per_page: data.items.per_page,
              total: data.items.total,
              last_page: data.items.last_page
            };
            break;
          case 'programa':
            programas.value = data.items.data;
            paginationPrograma.value = {
              current_page: data.items.current_page,
              per_page: data.items.per_page,
              total: data.items.total,
              last_page: data.items.last_page
            };
            break;
          case 'actividad':
            actividades.value = data.items.data;
            paginationActividad.value = {
              current_page: data.items.current_page,
              per_page: data.items.per_page,
              total: data.items.total,
              last_page: data.items.last_page
            };
            break;
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `No se pudieron cargar los ${getCurrentTabName()}`
        });
      } finally {
        loading.value = false;
      }
    };

    const getEndpointByTab = (tab: string) => {
      switch (tab) {
        case 'fuente': return 'fuente-financiamiento';
        case 'programa': return 'programa-poa';
        case 'actividad': return 'actividad-poa';
        default: return 'fuente-financiamiento';
      }
    };

    const showModal = (item: any) => {
      errors.value = {};
      currentItemType.value = activeTab.value;
      
      if (item) {
        isEditing.value = true;
        form.value = {
          codigo: item.codigo,
          nombre: getNombreField(item)
        };
      } else {
        isEditing.value = false;
        form.value = {
          codigo: '',
          nombre: ''
        };
      }
      modalVisible.value = true;
    };

    const getNombreField = (item: any) => {
      switch (activeTab.value) {
        case 'fuente': return item.fuente_financiamiento;
        case 'programa': return item.programa_poa;
        case 'actividad': return item.actividad_poa;
        default: return '';
      }
    };

    const handleSubmit = async () => {
      loadingForm.value = true;
      errors.value = {};
      
      const endpoint = getEndpoint();
      const data = {
        codigo: form.value.codigo,
        nombre: form.value.nombre
      };
      
      try {
        let response;
        
        if (isEditing.value) {
          response = await axios.post(`/parametros-poa/${endpoint}/${form.value.codigo}/update`, data);
        } else {
          response = await axios.post(`/parametros-poa/${endpoint}/save`, data);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: isEditing.value ? `${getCurrentTabName()} actualizado correctamente` : `${getCurrentTabName()} creado correctamente`
        });
        
        modalVisible.value = false;
        
        // Recargar datos del tab actual
        await loadTabData();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          errors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingForm.value = false;
      }
    };

    const handleSearch = async () => {
      const pagination = getCurrentPagination();
      pagination.current_page = 1;
      await loadTabData();
    };

    const handlePageChange = async (page: number) => {
      const pagination = getCurrentPagination();
      pagination.current_page = page;
      await loadTabData();
    };
    
    const confirmDelete = (item: any, tipo: string) => {
      const nombreItem = tipo === 'fuente' ? item.fuente_financiamiento : 
                        (tipo === 'programa' ? item.programa_poa : item.actividad_poa);
      const tituloItem = tipo === 'fuente' ? 'Fuente Financiamiento' :
                        (tipo === 'programa' ? 'Programa POA' : 'Actividad POA');
      
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar ${tituloItem}: ${nombreItem}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteItem(item.codigo, tipo);
        }
      });
    };
    
    const deleteItem = async (codigo: string, tipo: string) => {
      const endpoint = tipo === 'fuente' ? 'fuente-financiamiento' :
                      (tipo === 'programa' ? 'programa-poa' : 'actividad-poa');
      const tituloItem = tipo === 'fuente' ? 'Fuente Financiamiento' :
                        (tipo === 'programa' ? 'Programa POA' : 'Actividad POA');
      
      try {
        await axios.get(`/parametros-poa/${endpoint}/${codigo}/delete`);
        Swal.fire({
          icon: 'success',
          title: `${tituloItem} eliminado`,
          text: `${tituloItem} ha sido eliminado correctamente`
        });
        await loadTabData();
      } catch (error: any) {
        console.error('Error al eliminar:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || `No se pudo eliminar ${tituloItem}`
        });
      }
    };

    const generatePDF = () => {
      const endpoint = getEndpointByTab(activeTab.value);
      const params = filters.value.search ? { search: filters.value.search } : {};
      
      axios.get(`/parametros-poa/${endpoint}/reporte`, {
        params,
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte_${endpoint}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }).catch(error => {
        console.error('Error al generar PDF:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el PDF'
        });
      });
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    // Cargar datos iniciales del primer tab
    onMounted(async () => {
      await loadTabData();
    });
    
    return {
      fuentes,
      programas,
      actividades,
      filters,
      loading,
      activeTab,
      form,
      errors,
      loadingForm,
      isEditing,
      modalTitle,
      modalVisible,
      paginationFuente,
      paginationPrograma,
      paginationActividad,
      changeTab,
      handleSearch,
      handlePageChange,
      confirmDelete,
      hasPermission,
      showModal,
      handleSubmit,
      generatePDF,
      getCurrentTabName,
      getSearchPlaceholder,
      getFieldLabel,
      getMaxLength
    };
  }
};
</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 500px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
  .nav-tabs .nav-link {
    color: #495057;
    font-weight: 500;
    cursor: pointer;
  }
  .nav-tabs .nav-link.active {
    color: #D84315;
    font-weight: bold;
    border-bottom: 2px solid #D84315;
  }
  .nav-tabs .nav-link:hover {
    border-color: #e9ecef #e9ecef #dee2e6;
    isolation: isolate;
  }
</style>